export const blog = [ 
    {
        id:1,
        type:'family house',
        img:"https://images.pexels.com/photos/4205505/pexels-photo-4205505.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        name:'Robert Fox',
        date:'06 April, 20201',
        title:'Redfin Ranks the Most Competitive Neighborhoods of 2020',
        description:'Semper sagittis facilisi praesent elementum purus faucibus faucibus non tempus.',
        more:'read more'
    },
    {
        id:2,
        type:'apartment',
        name:'Robert Fox',
        date:'06 April, 20201',
        img:"https://images.pexels.com/photos/584399/living-room-couch-interior-room-584399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        title:'Housing Markets That Changed the  Most This Decade',
        description:'Semper sagittis facilisi praesent elementum purus faucibus faucibus non tempus.',
        more:'read more'
    },
    {
        id:3,
        type:'apartment',
        name:'Robert Fox',
        date:'06 April, 20201',
        img:"https://images.pexels.com/photos/1918291/pexels-photo-1918291.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        title:'Redfin Unveils the Best Canadian  Cities for Biking',
        description:'Semper sagittis facilisi praesent elementum purus faucibus faucibus non tempus. ',
        more:'read more'
    },
    {
        id:4,
        type:'rental',
        name:'Robert Fox',
        date:'06 April, 20201',
        img:"https://images.pexels.com/photos/277559/pexels-photo-277559.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        title:'You Can Buy The Piano Teacher’s Home from Groundhog Day',
        description:'Semper sagittis facilisi praesent elementum purus faucibus faucibus non tempus. ',
        more:'read more'
    },
]